// Exact published Magically Linked marketing paths. Add a route only when its page ships.
export const PUBLIC_CONTENT_PATHS: readonly string[] = ["/"];
